export default __webpack_public_path__ + "static/media/bidadvisor.2513e8f1.jpg";